export const version = "networks/5.0.7";
//# sourceMappingURL=_version.js.map